<nb-card class="lti-placement-dialog">
  <nb-card-header>
    <h4>
      {{ titleKey | translate }}
    </h4>
    <span class="lti-placement-dialog__registration">{{ registration.display_name }}</span>
  </nb-card-header>

  <nb-card-body>
    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="field">
        <label class="field__label" for="lti_context_id">
          {{ 'pages.tutors.placements.lti.field.contextId' | translate }}
        </label>

        <!-- Steht der Kurs fest, wird er gezeigt und nicht erneut erfragt. -->
        <ng-container *ngIf="contextFixed; else contextIdPicker">
          <p class="field__fixed">{{ fixedContextLabel }}</p>
          <p class="field__help">
            <a href="javascript:void(0)" (click)="changeContext()">
              {{ 'pages.tutors.placements.ilias.picker.changeCourse' | translate }}
            </a>
          </p>
        </ng-container>

        <!-- Auswahl aus dem synchronisierten Repository-Baum. Ohne sie müsste
             hier die ref_id abgetippt werden — eine Zahl, die im Portal
             nirgends steht und nur in der ILIAS-URL auftaucht. -->
        <ng-template #contextIdPicker>
        <ng-container *ngIf="usePicker; else contextIdManual">
          <nb-select
            fullWidth
            formControlName="lti_context_id"
            [placeholder]="'pages.tutors.placements.ilias.picker.placeholder' | translate"
          >
            <nb-option *ngFor="let obj of iliasObjects" [value]="obj.external_id">
              {{ objectLabel(obj) }}
            </nb-option>
          </nb-select>
          <p class="field__help">
            {{ 'pages.tutors.placements.ilias.picker.hint' | translate }}
            <a href="javascript:void(0)" (click)="useManualEntry()">
              {{ 'pages.tutors.placements.ilias.picker.switchToManual' | translate }}
            </a>
          </p>
        </ng-container>

        <ng-template #contextIdManual>
          <input
            id="lti_context_id"
            nbInput
            fullWidth
            formControlName="lti_context_id"
            [status]="form.get('lti_context_id')?.touched && form.get('lti_context_id')?.invalid ? 'danger' : 'basic'"
            placeholder="z.B. 42"
          />
          <p class="field__help">
            <span *ngIf="objectsLoading">{{ 'pages.tutors.placements.ilias.picker.loading' | translate }}</span>
            <span *ngIf="!objectsLoading">{{ 'pages.tutors.placements.lti.field.contextIdHint' | translate }}</span>
            <a
              *ngIf="manualEntry && iliasObjects.length"
              href="javascript:void(0)"
              (click)="usePickerAgain()"
            >
              {{ 'pages.tutors.placements.ilias.picker.switchToPicker' | translate }}
            </a>
          </p>
        </ng-template>
        </ng-template>
      </div>

      <div class="field" *ngIf="!hidesResourceLink">
        <label class="field__label" for="lti_resource_link_id">
          {{ 'pages.tutors.placements.lti.field.resourceLinkId' | translate }}
        </label>
        <input
          id="lti_resource_link_id"
          nbInput
          fullWidth
          formControlName="lti_resource_link_id"
          placeholder="—"
        />
        <p class="field__help">{{ 'pages.tutors.placements.lti.field.resourceLinkIdHint' | translate }}</p>
      </div>

      <div class="field">
        <label class="field__label">{{ 'pages.tutors.placements.lti.field.agent' | translate }}</label>
        <nb-select
          fullWidth
          formControlName="bot_id"
          [placeholder]="'pages.tutors.placements.lti.field.agentPlaceholder' | translate"
          [status]="form.get('bot_id')?.touched && form.get('bot_id')?.invalid ? 'danger' : 'basic'"
        >
          <nb-option *ngFor="let tutor of tutors" [value]="tutor.id">{{ tutorLabel(tutor) }}</nb-option>
        </nb-select>
      </div>

      <div class="field">
        <label class="field__label">{{ 'pages.tutors.placements.lti.field.course' | translate }}</label>
        <nb-select
          fullWidth
          formControlName="course_id"
          [placeholder]="'pages.tutors.placements.lti.field.coursePlaceholder' | translate"
        >
          <nb-option [value]="null">{{ 'pages.tutors.placements.lti.field.coursePlaceholder' | translate }}</nb-option>
          <nb-option *ngFor="let course of courses" [value]="course.id">{{ course.course_name }}</nb-option>
        </nb-select>
      </div>

      <div *ngIf="errorMessage" class="lti-placement-dialog__error">{{ errorMessage }}</div>
    </form>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton type="button" status="basic" (click)="cancel()">
      {{ 'buttons.cancel' | translate }}
    </button>
    <button nbButton type="button" status="primary" [disabled]="saving" (click)="save()">
      {{ (saving ? 'buttons.saving' : 'buttons.save') | translate }}
    </button>
  </nb-card-footer>
</nb-card>
